import { Link } from "react-router-dom";
import { useParentPath } from "@/lib/useParentPath";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const goBack = useParentPath();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="text-center max-w-sm">
        <div className="text-8xl font-bold text-border mb-4 leading-none">404</div>
        <h1 className="text-xl font-bold text-foreground mb-2">Pagina non trovata</h1>
        <p className="text-sm text-muted-foreground mb-8 leading-relaxed">
          La pagina che stai cercando non esiste o è stata spostata.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={goBack}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-border text-sm font-medium text-muted-foreground hover:border-primary hover:text-primary transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Indietro
          </button>
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary/90 transition-colors"
          >
            <Home className="h-4 w-4" /> Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
